import { useEffect, useState } from "react";
import { POOL_ENDED, POOL_NOT_LIVE, POOL_OPEN } from "../../utils/constants";


const usePoolStatus = (poolstart, poolend, poolsdetail) => {
    const [pollStatus, setPollStatus] = useState("");
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        const startTime = new Date(poolstart);
        const endTime = new Date(poolend);

        const update = () => {
            const now = new Date();
            let status = "";
            let targetDate = null;
            if (now >= endTime) {
                status = POOL_ENDED;
                targetDate = endTime;
                setIsDisabled(true);
            } else if (now < startTime) {
                status = POOL_NOT_LIVE;
                targetDate = startTime;
                setIsDisabled(true);
            } else {
                status = POOL_OPEN;
                targetDate = endTime;
                setIsDisabled(false);
            }
            setPollStatus(status);

            if (targetDate) {
                const diff = targetDate.getTime() - now.getTime();
                const safe = (val) => (isNaN(val) || val < 0 ? 0 : val);

                setTimeLeft({
                    days: safe(Math.floor(diff / (1000 * 60 * 60 * 24))),
                    hours: safe(Math.floor((diff / (1000 * 60 * 60)) % 24)),
                    minutes: safe(Math.floor((diff / (1000 * 60)) % 60)),
                    seconds: safe(Math.floor((diff / 1000) % 60)),
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [poolstart, poolend, poolsdetail]);

    useEffect(() => {
        if (!poolsdetail) return;

        const start = new Date(poolsdetail.startDate).getTime();
        const end = new Date(poolsdetail.endDate).getTime();
        const currentTime = new Date().getTime();

        if (currentTime < start || currentTime > end) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [poolsdetail]);

    return { pollStatus, timeLeft, isDisabled };
};

export default usePoolStatus;
